import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { addNewUser } from "../../actions/ManageUserAction";
import Loading from "../Layout/Loading";
import EntryFormContent from "./EntryFormContent";
import { createUser } from "../../services/manageUserService";

const CreateUser = ({ closeModal: parentCloseModal, refreshData }) => {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    phone_number: "",
    email: "",
    distributor_name: "",
    GroupName: "",
  });
  const [loading, setLoading] = useState(false);
  // Check if the screen is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // Same breakpoint as sm in Tailwind //FIXME: check screen size
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      parentCloseModal();
    }, 400);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleSubmit = async () => {
    if (
      !formData.username ||
      !formData.GroupName ||
      !formData.phone_number ||
      !formData.email ||
      !formData.password ||
      !formData.distributor_name.length
    ) {
      toast.error("Please fill all required fields.");
      return;
    }
    if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (!validatePassword(formData.password)) {
      toast.error(
        "Password must be at least 8 characters long and include at least one uppercase letter,one lowercase letter , one number, and one special character."
      );
      return;
    }
    if (!formData.phone_number.startsWith("+")) {
      formData.phone_number = "+" + formData.phone_number;
    }
    let nickname = formData.username;
    let name = nickname.toLowerCase();
    let username = name.replace(/\s/g, "");

    formData.name = username;
    formData.nickname = nickname;
    formData.username = username;

    if (formData.GroupName === "Avana_Employee") {
      formData.category = "Internal-user-profile";
      formData.profile = "Internal";
    } else if (formData.GroupName === "Distributor") {
      formData.category = "user-profile";
      formData.profile = "External";
    } else if (formData.GroupName === "Distributor_Admin") {
      formData.category = "distributor-admin-profile";
      formData.profile = "External";
    } else if (formData.GroupName === "Manager") {
      formData.category = "manager-profile";
      formData.profile = "Internal";
    }
    formData.msg = "Signup Frontend";
    formData.UserId = "";
    formData.timestamp = "";
    formData.team = "";
    formData.assigner = "";
    formData.assignername = "";
    console.log("formData", formData);

    setLoading(true);
    try {
      const response = await createUser(formData);
      console.log("response", response.data);
      // if (response.statusCode === 200) {
      toast.success("Successfully added");
      refreshData();
      closeModal();
      // } else {
      //   toast.error("Error occurred");
      // }
    } catch (error) {
      console.error("Error from backend:", error);

      if (error.response) {
        // Server responded with an error status code (like 500)
        const awsError =
          error.response.data?.error || "An unknown error occurred";
        toast.error(`AWS Error: ${awsError}`);
      } else if (error.request) {
        // Request was made but no response
        toast.error("No response from server. Please check your network.");
      } else {
        // Other errors (like setting up request)
        toast.error(`Unexpected error: ${error.message}`);
      }
      // toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <AnimatePresence>
        {isOpen &&
          (isMobile ? (
            // Mobile dialog (centered, no animation)
            <div
              ref={modalRef}
              className="bg-white w-[85vw] max-w-[800px] rounded-lg max-h-[800px] px-6 shadow-lg h-[85vh]"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <EntryFormContent
                    formData={formData}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    handleCancel={parentCloseModal}
                    type="Create"
                  />
                </>
              )}
            </div>
          ) : (
            // Desktop slide-in panel
            <motion.div
              ref={modalRef}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.4 }}
              className="bg-white w-[60vw] h-full px-6 absolute right-0 top-0 shadow-lg"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <button
                    onClick={closeModal}
                    className="absolute top-0 -left-12 bg-gray-200 rounded-md p-1 shadow-md hidden sm:block"
                  >
                    <X className="w-7 h-7 text-gray-500 hover:text-gray-800" />
                  </button>
                  <div className="pt-4">
                    <EntryFormContent
                      formData={formData}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      type="Create"
                    />
                  </div>
                </>
              )}
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default CreateUser;
